<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 sm12 lg9>
          <v-card>
            <v-card-title>
              <h3 class="display-1">Protokolle</h3>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="protocols"
                :pagination.sync="pagination"
                class="protocols-table"
                hide-actions
                item-key="key"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <router-link
                      v-if="$isSuperuser()"
                      :to="{
                        name: 'show-protocol',
                        params: { id: props.item.id, type: props.item.type }
                      }"
                    >
                      {{ getTitle(props.item) }}
                    </router-link>
                    <a v-else href="javascript:;" @click="props.item.file.download()">
                      {{ getTitle(props.item) }}
                    </a>
                  </td>
                  <td>
                    {{ props.item.file.size }}
                  </td>
                  <td class="text-xs-right">
                    <v-btn icon @click="props.item.file.download()" title="Herunterladen">
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-btn
        v-if="$isSuperuser()"
        :to="{ name: 'new-protocol' }"
        color="green"
        dark
        fixed
        bottom
        right
        fab
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-container>
  </BaseLayout>
</template>

<script>
import Session from '@/models/session';
import File from '@/models/file';
import Protocol from '@/models/protocol';
import orderby from 'lodash.orderby';

export default {
  name: 'IndexProtocols',
  async initialAsyncData() {
    await Promise.all([
      Session.fetchAll(),
      File.fetchAll(),
      Protocol.fetchAll(),
    ]);
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'file.name' },
        { text: 'Grösse', value: 'file.size' },
        { text: '', sortable: false, align: 'right' },
      ],
      pagination: {
        sortBy: 'name',
        rowsPerPage: -1,
      },
    };
  },
  methods: {
    getTitle(protocol) {
      if (protocol.title) {
        return protocol.title;
      }
      return `Grossratsprotokoll vom ${this.$options.filters.toLocaleDateString(protocol.date)}`;
    },
  },
  computed: {
    protocols() {
      const sessions = Session.query().all();
      const protocols = Protocol.query().all();
      return orderby(sessions
        .map(s => ({
          id: s.id,
          key: `s-${s.id}`,
          date: s.date,
          file: s.protocol,
          type: 'session',
        }))
        .concat(protocols.map(p => ({
          id: p.id,
          key: `p-${p.id}`,
          date: p.date,
          file: p.file,
          type: 'protocol',
          title: p.title,
        }))), 'date', 'desc')
        .filter(p => p.file);
    },
  },
};
</script>
